import React, { useState, useEffect } from 'react';

import Toast from './Toast';

let showToast: any;

const ToastManager = () => {
  const [toasts, setToasts] = useState([]);
  showToast = (message: any, duration = 3000, position = "top") => {
    const id = Date.now(); // 生成唯一的ID
    const obj = { id, message, duration, position };
    setToasts((prevToasts) => [...prevToasts, obj]);
  };
  const removeToast = (id: any) => {
    setToasts((prevToasts) => prevToasts.filter((toast: any) => toast.id !== id));
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      if (toasts.length > 0) {
        removeToast(toasts[0].id); // 移除第一个Toast
      }
    }, toasts[0]?.duration || 3000);
    return () => clearTimeout(timer);
  }, [toasts]);
  return (
    <div>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          duration={toast.duration}
          position={toast.position}
        />
      ))}
    </div>
  );
};
export { ToastManager, showToast };